import { inicialesDe } from "../../functions/imageFunctions";
import "./css/Avatar.css";

// Color de respaldo determinístico a partir del nombre, para que cada
// persona tenga siempre el mismo color de iniciales (no uno random que
// cambie en cada render). Van con letra blanca: cada uno pasa 4,5 a 1.
const COLORES = [
  "#2E6FE0",
  "#1A8648",
  "#B25D0B",
  "#9B59B6",
  "#DE2D33",
  "#128286",
];

const colorDe = (texto) => {
  const codigo = (texto || "").split("").reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return COLORES[codigo % COLORES.length];
};

const Avatar = ({ nombreCompleto, fotoUrl, size = 28, title }) => {
  if (fotoUrl) {
    return (
      <img
        className="avatar-img"
        src={fotoUrl}
        alt={nombreCompleto || "Avatar"}
        title={title || nombreCompleto}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <span
      className="avatar-iniciales"
      title={title || nombreCompleto}
      style={{
        width: size,
        height: size,
        background: colorDe(nombreCompleto),
        fontSize: size * 0.4,
      }}
    >
      {inicialesDe(nombreCompleto)}
    </span>
  );
};

export default Avatar;
